<template>
  <v-card flat class="rounded">
    <v-card-title class="profile-card-title">تنظیمات پروفایل</v-card-title>
    <v-divider class="mx-4 my-0"/>

    <v-card-text>
      <v-card-title>تغییر رمز ورود</v-card-title>
      <v-card-subtitle>رمز ورود به حساب کاربری خود را تغییر دهید.</v-card-subtitle>
      <v-divider inset class="mt-0"/>

      <v-row no-gutters>
        <v-slide-y-transition>
          <v-col cols="12" class="pa-2" v-if="alertModel">
            <v-hover v-slot="{ hover }">
              <v-alert border="left" color="warning" dark :dismissible="hover" v-model="alertModel">
                <template v-slot:prepend>
                  <v-icon class="me-2">mdi-alert-box</v-icon>
                </template>
                اگر تا به امروز رمز عبور خود را وارد نکرده اید، تیک ثبت رمز ورود را فعال نمایید.
              </v-alert>
            </v-hover>
          </v-col>
        </v-slide-y-transition>

        <v-col cols="12" md="6" class="pa-2">
          <label for="prePass">رمز ورود فعلی</label>
          <v-text-field id="prePass" outlined placeholder="رمز ورود فعلی" @click:append="prePass = !prePass"
                        :append-icon="prePass ? 'mdi-eye' : 'mdi-eye-off'" dense
                        :type="!prePass ? 'password' : 'text'"/>
        </v-col>

        <v-col cols="12" md="6" class="pa-2">
          <label for="setPass">ثبت رمز ورود</label>
          <v-checkbox id="setPass" class="ma-0" label="افزودن رمز ورود"/>
        </v-col>

        <v-col cols="12" md="6" class="pa-2">
          <label for="newPass">رمز ورود جدید</label>
          <v-text-field id="newPass" outlined placeholder="رمز ورود جدید" @click:append="newPass = !newPass"
                        :append-icon="newPass ? 'mdi-eye' : 'mdi-eye-off'" dense
                        :type="!newPass ? 'password' : 'text'"/>
        </v-col>

        <v-col cols="12" md="6" class="pa-2">
          <label for="rePass">تکرار رمز ورود</label>
          <v-text-field id="rePass" outlined placeholder="تکرار رمز ورود" @click:append="rePass = !rePass"
                        :append-icon="rePass ? 'mdi-eye' : 'mdi-eye-off'" dense :type="!rePass ? 'password' : 'text'"/>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="justify-end pa-4">
      <v-btn color="primary" large class="rounded-lg" depressed width="120">
        <v-icon class="me-2">mdi-check</v-icon>
        ثبت تغییرات
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "profileSetting",

  data: () => ({
    alertModel: true,
    prePass: false,
    newPass: false,
    rePass: false
  })
}
</script>

<style scoped lang="scss">
.profile-card-title {
  position: relative;

  &:before {
    content: '';
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 24px;
    background: dodgerblue;
    border-radius: 8px;
  }
}
</style>

<style scoped>
.v-input--checkbox :deep(.v-label) {
  margin: 0 !important;
}
</style>